import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=31167be3&"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPage.vue?vue&type=style&index=0&id=31167be3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports